import * as Service from '../../../common_services';

export default {
  /**
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllCountries({ commit }) {
    const response = await Service.getMerchantCountries();
    commit('setProperty', { payload: response.data, property: 'countries' });
  },

  /**
   *
   * @param commit
   * @param countryId
   * @returns {Promise<void>}
   */
  async fetchCountryStates({ commit }, { countryId }) {
    const response = await Service.getMerchantStates(countryId);
    commit('setProperty', { payload: response, property: 'states' });
  },

  /**
   *
   * @param commit
   * @param stateId
   * @returns {Promise<void>}
   */
  async fetchStateCities({ commit }, { stateId }) {
    const response = await Service.getMerchantCities(stateId);
    commit('setProperty', { payload: response, property: 'cities' });
  },
};
